// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBvYA5Kw_ISaWFo0pz6nUPj2zfZjdv1udk",
    authDomain: "furniture-shopping-0311.firebaseapp.com",
    databaseURL: "https://furniture-shopping-0311.firebaseio.com",
    projectId: "furniture-shopping-0311",
    storageBucket: "furniture-shopping-0311.appspot.com",
    messagingSenderId: "817133444128"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
